<div class="maintenance" *ngIf="isMaintenance">
  <div class="row">
    <div class="maintenance-dialog col-10 col-lg-6 offset-1 offset-lg-3 mt-5">
      <h1>{{ 'MAINTENANCE.MAINTENANCE' | transloco }}</h1>
      <p class="mt-3 mb-1">{{ 'MAINTENANCE.TEXT1' | transloco }}</p>
      <p>{{ 'MAINTENANCE.TEXT2' | transloco }}</p>
    </div>
  </div>
</div>
